const WORKFORCE_HISTORY_LABELS = Object.freeze({
    timesheet_presence_baseline: 'Присутствие принято по табелям при запуске',
    timesheet_arrival_confirmed: 'Прибытие подтверждено при вводе часов',
    timesheet_arrival_cancelled: 'Отменено прибытие, подтверждённое при вводе часов',
    timesheet_arrival_discrepancy_accepted: 'Объяснено расхождение часов и прибытия',
    workforce_plan_range_changed: 'Изменён диапазон плана',
    workforce_plan_arrival_confirmed: 'Подтверждено прибытие по плану',
    workforce_plan_arrival_corrected: 'Исправлено прибытие по плану',
    workforce_plan_arrival_cancelled: 'Отменено подтверждение прибытия по плану',
    workforce_planned_object_linked: 'План сотрудника связан с объектом',
    workforce_planned_object_cancelled: 'Отменён плановый объект сотрудника',
    workforce_planned_object_fact_linked: 'Фактическое назначение связано с объектом',
    workforce_planned_object_fact_cancelled: 'Отменено назначение на плановый объект'
});

function historyDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
    return match ? `${match[3]}.${match[2]}.${match[1]}` : '';
}

function historyPeriod(start, exclusiveEnd) {
    const first = historyDate(start);
    if (!exclusiveEnd) return first ? `с ${first}` : 'Период не указан';
    const end = new Date(`${String(exclusiveEnd).slice(0, 10)}T00:00:00Z`);
    if (Number.isNaN(end.getTime())) return first || 'Период не указан';
    end.setUTCDate(end.getUTCDate() - 1);
    const last = historyDate(end.toISOString());
    return first === last ? first : `${first} — ${last}`;
}

function planSegmentsText(segments, emptyText) {
    if (!Array.isArray(segments)) return 'Прежние данные не сохранены полностью';
    if (!segments.length) return emptyText;
    return segments.map(segment => [
        `${historyPeriod(segment.starts_on, segment.ends_on)}: ${segment.target_name}`,
        segment.loupe_reason ? `Причина: ${segment.loupe_reason}` : '',
        segment.note ? `Примечание: ${segment.note}` : ''
    ].filter(Boolean).join('\n')).join('\n');
}

function workforceHistoryDescription(event) {
    const context = event && event.context || {};
    const changes = event && event.changes || {};
    if (event && event.event_type === 'timesheet_arrival_discrepancy_accepted') {
        return [`Дата прибытия: ${historyDate(changes.arrival_date)}`,
            ...(changes.affected_entries || []).map(row => `${historyDate(row.work_date)}: ${Number(row.worked_minutes) / 60} ч.`),
            `Объяснение: ${changes.reason || ''}`].join('\n');
    }
    if (event && event.event_type === 'timesheet_presence_baseline') {
        return `${changes.reason || event.description}\nИсточник: табели · перенос ${changes.rollout_key || ''}`;
    }
    if (context.plan) {
        const plan = context.plan;
        const after = Array.isArray(plan.after)
            ? planSegmentsText(plan.after, 'План очищен')
            : 'Данные не сохранены полностью';
        return `Период: ${historyPeriod(plan.starts_on, plan.ends_on)}\nБыло:\n${
            planSegmentsText(plan.before, 'Не запланировано')
        }\nСтало:\n${after}`;
    }
    if (/^workforce_plan_arrival_/.test(event && event.event_type || '')) {
        const target = context.target || context.assignment || context.object_assignment;
        return [changes.arrival_date ? `Дата прибытия: ${historyDate(changes.arrival_date)}` : '',
            target ? `Место: ${target.target_name}` : event.description].filter(Boolean).join('\n');
    }
    if (event && event.event_type === 'employee_workforce_visibility_changed') {
        const labels = {inherit: 'По общим настройкам', show: 'Показывать', hide: 'Скрывать'};
        const oldValue = changes.old || {};
        const newValue = changes.new || {};
        return [`${changes.view === 'board' ? 'Доска' : 'План'}: ${labels[oldValue.mode] || 'Не указано'} → ${labels[newValue.mode] || 'Не указано'}`,
            event.description].filter(Boolean).join('\n');
    }
    if (context.previous_assignment && context.assignment) {
        return `${context.previous_assignment.target_name} → ${context.assignment.target_name}`;
    }
    if (context.assignment) return `Новое место: ${context.assignment.target_name}`;
    if (context.planned_move) return `Запланировано: ${context.planned_move.target_name}`;
    if (context.object_assignment) return `Объект: ${context.object_assignment.target_name}`;
    if (context.target) return context.target.target_name;
    return event && event.description || '';
}

module.exports = {WORKFORCE_HISTORY_LABELS, historyDate, historyPeriod, workforceHistoryDescription};
